import { type BucketExperimentsResponse } from '../aliases';
import { type CachedExperiments } from '../types';

import { getLogger } from '@/modules/observability/logging';

/**
 * Checks for variant mismatches between cached experiments and bucketing response
 *
 * We've been asked to keep track of any mismatches as the variants in the
 * cache (preview endpoint) should be exactly the same as the variants returned
 * after a successful bucket
 */
export function checkVariantMismatches(
  cachedExps: CachedExperiments | undefined,
  bucketResponse: BucketExperimentsResponse
): void {
  for (const exp in bucketResponse) {
    if (cachedExps?.[exp]?.decision !== bucketResponse[exp]?.variant) {
      getLogger().warn(`[JIT Bucketing] cached variant mismatch for ${exp}`);
    }
  }
}
